import React from 'react';
import { Button, Modal } from 'antd';
import { BaseModal, BaseModalFooter } from 'components/wrappers/BaseModal';

import styles from './RateChangeConfirmationModal.module.less';

type Props = {
  open: boolean;
  onCancel: () => void;
  onApplyToAllActiveAssignments: () => void;
  onApplyOnlyToNewAssignments: () => void;
};

export default function RateChangeConfirmationModal(props: Props) {
  const {
    open,
    onCancel,
    onApplyToAllActiveAssignments,
    onApplyOnlyToNewAssignments,
  } = props;

  const handleApplyToAllActiveAssignments = () => {
    Modal.confirm({
      title:
        'This update will be applied to all active and pending assignments. Are you sure?',
      icon: <span className="icon icon-attention-filled" />,
      onOk() {
        onApplyToAllActiveAssignments();
      },
      onCancel() {},
    });
  };

  const handleApplyOnlyToNewAssignments = () => {
    Modal.confirm({
      title:
        'This update will be applied only to new assignments. Are you sure?',
      icon: <span className="icon icon-attention-filled" />,
      onOk() {
        onApplyOnlyToNewAssignments();
      },
      onCancel() {},
    });
  };

  return (
    <BaseModal
      title="Rate Change Confirmation"
      maxWidth={700}
      open={open}
      onCancel={onCancel}
      closable={true}
    >
      <div className="modal-scroll-wrapper">
        <p>A new VMS and/or MSP rate has been applied.</p>
        <p>
          Do you want to apply this change to all active and pending assignments
          for this customer, or only to new assignments going forward?
        </p>
      </div>

      <BaseModalFooter className={styles.footer} justify="flex-start">
        <div className={styles.footerInner}>
          <Button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </Button>
          <div className={styles.primaryGroup}>
            <Button
              type="primary"
              onClick={handleApplyToAllActiveAssignments}
            >
              Apply to all active and pending assignments
            </Button>
            <Button type="primary" onClick={handleApplyOnlyToNewAssignments}>
              Apply only to new assignments
            </Button>
          </div>
        </div>
      </BaseModalFooter>
    </BaseModal>
  );
}
